(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderAir',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var departure_airport = $('#fitbuilderair-departure_airport'),
			departure_time    = $('#fitbuilderair-departure_time'),
			arrival_airport   = $('#fitbuilderair-arrival_airport'),
			arrival_time      = $('#fitbuilderair-arrival_time'),
			departure_date    = $('#fitbuilderair-departure_date'),
			component_index,
			component_departure_date;

		// set the departure date based on component if coming from add trip summary screen
		if ($('#fit-builder-component-index')) {
			component_index          = $('#fit-builder-component-index').val();
			component_departure_date = $('#start-date-' + component_index + '_hidden').val();

			if (component_departure_date && departure_date.data('DateTimePicker') !== undefined) {
				departure_date.data('DateTimePicker').date(component_departure_date);
			}
		}

		$('.get-flights').click(function _getFlights(e) {
			e.preventDefault();

			getFlights();
		});

		$('.flight-search-results').on('click', '.select-flight', function _setFlightDetails() {
			departure_airport.val($(this).data('departure-iata'));
			arrival_airport.val($(this).data('arrival-iata'));

			departure_time.val($(this).data('departure-time'));
			arrival_time.val($(this).data('arrival-time'));
		});

		Adzuki.Typeahead(
			$('#fitbuilderair-departure_airport'),
			'/Airports/search',
			function _selected_airport(airport, $self, typeahead)
			{
				if (airport.id) {
					typeahead.setHiddenValue(airport.id);

					$('#fitbuilderair-departure_airport_id').val(airport.id);
					$('#fitbuilderair-departure_airport').prop('disabled', true);
					$('.reset-departure-airport').removeClass('hidden');
				} else {
					$self.val('');
				}
			}
		);

		$('#reset-departure-airport-link').click(function _resetDepartureAirport(e) {
			e.preventDefault();

			$('#fitbuilderair-departure_airport').val('');
			$('#fitbuilderair-departure_airport_id').val('');
			$('#fitbuilderair-departure_airport').prop('disabled', false);
			$('.reset-departure-airport').addClass('hidden');
		});

		Adzuki.Typeahead(
			$('#fitbuilderair-arrival_airport'),
			'/Airports/search',
			function _selected_airport(airport, $self, typeahead)
			{
				if (airport.id) {
					typeahead.setHiddenValue(airport.id);

					$('#fitbuilderair-arrival_airport_id').val(airport.id);
					$('#fitbuilderair-arrival_airport').prop('disabled', true);
					$('.reset-arrival-airport').removeClass('hidden');
				} else {
					$self.val('');
				}
			}
		);

		$('#reset-arrival-airport-link').click(function _resetDepartureAirport(e) {
			e.preventDefault();

			$('#fitbuilderair-arrival_airport').val('');
			$('#fitbuilderair-arrival_airport_id').val('');
			$('#fitbuilderair-arrival_airport').prop('disabled', false);
			$('.reset-arrival-airport').addClass('hidden');
		});
	};

	form.success = function success(response)
	{
		var form_data,
			component_index,
			start_date,
			start_time,
			start_date_time,
			end_date,
			end_time,
			end_date_time,
			modal_start_date_time,
			modal_end_date_time;

		if ($('#fitbuilderair-adding').val() === '1') {
			if (!Adzuki.Form.hasError(response)) {
				if ($('#fit-builder-component-index')) {
					component_index       = $('#fit-builder-component-index').val();
					start_date            = $('#start-date-' + component_index + '_hidden');
					start_time            = $('#start-date-' + component_index + '-time_hidden');
					end_date              = $('#end-date-' + component_index + '_hidden');
					end_time              = $('#end-date-' + component_index + '-time_hidden');
					modal_start_date_time = $('#fitbuilderair-departure_time').val();
					modal_end_date_time   = $('#fitbuilderair-arrival_time').val();

					// build full date/time strings
					start_date_time = start_date.val() + ' ' + start_time.val();
					end_date_time   = end_date.val() + ' ' + end_time.val();

					// format them
					start_date_time       = moment(start_date_time).format('YYYY-MM-DD HH:mm');
					end_date_time         = moment(end_date_time).format('YYYY-MM-DD HH:mm');
					modal_start_date_time = moment(modal_start_date_time).format('YYYY-MM-DD HH:mm');
					modal_end_date_time   = moment(modal_end_date_time).format('YYYY-MM-DD HH:mm');

					if (start_date_time !== modal_start_date_time) {
						// start date/time between component and details doesn't match, update component in form
						$('#start-date-' + component_index).data("DateTimePicker").date(moment(modal_start_date_time));
						$('#start-date-' + component_index + '-time').data("DateTimePicker").date(moment(modal_start_date_time));
					}

					if (end_date_time !== modal_end_date_time) {
						// end date/time between component and details doesn't match, update component in form
						$('#end-date-' + component_index).data("DateTimePicker").date(moment(modal_end_date_time));
						$('#end-date-' + component_index + '-time').data("DateTimePicker").date(moment(modal_end_date_time));
					}
				}

				form_data = $('#fit-builder-air').serialize();

				$('#saved_details_' + component_index).val(form_data);
				$('#fit-builder-details-type-message-' + component_index).removeClass('hidden');
				$('.fit-builder-detail-link[data-i="' + component_index + '"]').addClass('hidden');

				$('.modal').modal('hide');
			}
		} else {
			// eslint-disable-next-line no-lonely-if
			if (!Adzuki.Form.hasError(response)) {
				window.location.href = response['data'];
				return true;
			}
		}
	};

	function getFlights()
	{
		var airline         = $('#fitbuilderair-airline_id').val(),
			flight_num      = $('#fitbuilderair-flight_number').val(),
			date            = $('#fitbuilderair-departure_date').val(),
			formatted_date;

		// reformat the date
		formatted_date =  moment(date).format("YYYY-MM-DD");

		Adzuki.Ajax.get('/FlightStats/airSearch/' + airline + '/' + flight_num + '/' + formatted_date + '/1')
		.then(function _receiveContent(response) {
			if (response.error) {
				$('.flight-search-results').addClass('hidden');
				Adzuki.StatusMessage('error', 'Sorry, that flight cannot be found');
			} else {
				$('.flight-search-results').removeClass('hidden');
				$('.flight-search-results').html(response);
			}
		});
	}
}(jQuery, window.Adzuki || {}));